<template>
  <div class="columns is-mobile is-centered">
    <div class="column">
      <button class="button is-info is-small" @click="logData()">Log Data to Console</button>
      <div class="tabs">
        <ul>
          <li v-for="life in lifeList" :key="life" :class="selectedLife == life ? 'is-active' : ''">
            <a href="#" @click="selectedLife = life">
              {{ life }}
            </a>
          </li>
        </ul>
      </div>

      <div>
        <button @click="showCompletedTasks = !showCompletedTasks" class="button is-primary is-small is-pulled-right" v-html="showCompletedTasks ? 'Hide Completed Tasks' : 'Show Completed Tasks'"></button>
      </div>

      <div v-for="rank in currentLifeRanks" :key="rank">
        <span class="tag has-text-weight-semibold	is-pulled-left is-medium">Rank: {{ rank }}</span>

        <table class="table is-striped is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Task</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-if="filterChallengesByRank(rank).length <= 0">
              <td colspan="2">Non Applicable / All Completed</td>
            </tr>

            <tr v-for="challenge in filterChallengesByRank(rank)" :key="challenge.description">
              <td v-html="challenge.description" :class="challenge.completed ? 'striked-text': ''" />
              <td>
                <button v-if="!challenge.completed" @click="completeChallenge(challenge)" class="button is-primary is-small is-fullwidth">Complete</button>
                <button v-else @click="restoreChallenge(challenge)" class="button is-warning is-small is-fullwidth">Restore</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import LifeChallenges from '../assets/life_challenges.json';

export default {
  name: 'home',
  data() {
    return {
      selectedLife: "",
      lives: LifeChallenges,
      showCompletedTasks: false
    }
  },

  computed: {
    lifeList() {
      return this.lives.map(life => life.name);
    },

    currentLife() {
      if (this.selectedLife) {
        let filtered = this.lives.find(life => life.name === this.selectedLife);
        if (filtered) return filtered;        
      }
      
      return this.lives[0];
    },

    currentLifeOpenChallenges() {
      return this.currentLife.challenges.filter(challenge => !challenge.completed || this.showCompletedTasks);
    },

    currentLifeRanks() {
      return new Set(this.currentLife.challenges.map(challenge => challenge.rank));
    }
  },

  created() {
    this.$http.get('https://bitbucket.org/rafaoliveira/fantasy-life/raw/master/src/assets/life_challenges.json')
      .then(res => this.lives = res.body);
  },

  methods: {
    completeChallenge(challenge) {
      challenge.completed = true;
    },

    restoreChallenge(challenge) {
      challenge.completed = false;
    },

    filterChallengesByRank(rank) {
      return this.currentLifeOpenChallenges.filter(challenge => challenge.rank === rank);
    },

    logData() {
      console.log(JSON.stringify(this.lives));
    }
  }
}
</script>

<style scoped>
li {
  display: inline;
  list-style: none;
  padding: 3px;
}

.tabs ul {width:100%;flex-direction:row;flex-wrap:wrap;}
.tabs li {width:10%}

.striked-text {
  text-decoration: line-through;
}
</style>